import { validateRequired, validateLength,validateNotNull } from "../../../../helpers/validationsForm";

const Inputs = (selectViewValue) => {

  return [
    {
      id: 1,
      label: "Nombre de la sucursal",
      name: "nombre",
      type: "text",
      placeholder: "Ingrese el nombre de la sucursal",
      validation: (value) => {
        const requiredError = validateRequired(value);
        if (requiredError) return requiredError;

        return validateLength(value, { minLength: 3, maxLength: 60 });
      }
    },
    {
      id: 2,
      label: "Dirección",
      name: "direccion",
      type: "text",
      placeholder: "Ingrese la dirección",
      validation: (value) => {
        const requiredError = validateRequired(value);
        if (requiredError) return requiredError;

        return validateLength(value, { minLength: 5, maxLength: 100 });
      }
    },
    {
      id: 3,
      label: "Teléfono",
      name: "telefono",
      type: "text",
      placeholder: "Ingrese el teléfono",
      validation: (value) => {
        const requiredError = validateRequired(value);
        if (requiredError) return requiredError;

        return validateLength(value, { minLength: 7, maxLength: 20 });
      }
    },
    {
      id: 4,
      label: "Horario",
      name: "horario",
      type: "text",
      placeholder: "Ej: Lun-Vie 9 a 18 hs",
      validation: (value) => {
        const requiredError = validateRequired(value);
        if (requiredError) return requiredError;

        return validateLength(value, { minLength: 5, maxLength: 50 });
      }
    },
    {
      id: 5,
      label: "Latitud",
      name: "latitud",
      type: "text",
      placeholder: "Ingrese latitud (ej: -34.6037)",
      validation: validateRequired
    },
    {
      id: 6,
      label: "Longitud",
      name: "longitud",
      type: "text",
      placeholder: "Ingrese longitud (ej: -58.3816)",
      validation: validateRequired
    },
    {
      id: 7,
      label: "Enlace Externo de Google Maps",
      name: "ubicacion",
      type: "text",
      placeholder: "Pegue el enlace de Google Maps",
      validation: validateRequired
    },

    // ---------- SELECT VIEW ----------
    {
      id: 8,
      label: "Elija el tipo de vista",
      name: "selectView",
      type: "select",
      options: [
        { value: 'vistaImagen', label: 'Mostrar Imagen' },
        { value: 'vistaMaps', label: 'Mostrar Visualización de Google Maps' },
      ],
      placeholder: "Tipo de vista", 
      defaultValue: selectViewValue // Aquí pasamos el parámetro selectViewValue
    },

    // ---------- IMAGEN SOLO SI selectView === "vistaImagen" ----------
    {
      id: 9,
      label: "Imagen de la sucursal",
      name: "imagen",
      type: "file",
      accept: "image/*",
      placeholder: "Seleccione una imagen de la sucursal",
      hidden: selectViewValue !== "vistaImagen",
      validation: (value, form) => {
        if (form.selectView === "vistaImagen") {
          if (!value && !form.id) return "Debe cargar una imagen.";
        }
        return null;
      }
    },

    // ---------- MAPS SOLO SI selectView === "vistaMaps" ----------
    {
      id: 10,
      label: "Vista de la sucursal en Google Maps",
      name: "imagen_maps",
      type: "text",
      placeholder: "Pegue el enlace de Google Maps",
      hidden: selectViewValue !== "vistaMaps",
      validation: (value, form) => {
        if (form.selectView === "vistaMaps") {
          return validateRequired(value);
        }
        return null;
      }
    }  ,
    {
          id: 11,
          label: "Sucursal Activa Para Web?",
          name: "suc_show_web",
          type: "select",
          options: [
            { value: true, label: 'Activo' },
            { value: false, label: 'Inactivo' },
          ],
          placeholder: "Seleccione estado",
          validation: (value, form) => {
            const requiredError = validateNotNull(value);
            return requiredError;
          },
        }
  ];
};

export default Inputs;
